export default __webpack_public_path__ + "static/media/BOD Special Meeting 16 March 2021.7b22f486.pdf";